import React from 'react';
import Layout from '../components/Layout';
// 使用命名导入而不是默认导入
import { MarkdownEditor } from '../components/MarkdownEditor';
// 或者如果有多个组件需要导入
// import { MarkdownEditor, OtherComponent } from '../components/MarkdownEditor';
import Tools from '../components/Tools';

const HomePage: React.FC = () => {
    return (
        <Layout>
            <div className="container home-page">
                <MarkdownEditor />
                <Tools />
            </div>
        </Layout>
    );
};

export default HomePage;